import { render, staticRenderFns } from "./question-content.vue?vue&type=template&id=224ec61f&"
import script from "./question-content.vue?vue&type=script&lang=js&"
export * from "./question-content.vue?vue&type=script&lang=js&"
import style0 from "./question-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports